import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import CharacterOverviewCard from './CharacterOverviewCard'
import AsyncElements from './AsyncElements'
import headerImage from '../assets/img/banners/Explore_Plan_Cover.jpg'
import ImageHeader from './ImageHeader'
import ProfileCard from './ProfileCard'
import Breadcrumbs from './Breadcrumbs'
import SingleProfileQuestOverview from './SingleProfileQuestOverview'

const StudentDashboard = props => {
  const { profiles, profileId, currentProfile, assignments, questAttempts, quests, crudAction, isReading, isInitializing } = props

  const getCompletedQuestCount = ()=> {
    const attemptList = _.map(questAttempts, (attempt,uuid)=>attempt) || []
    const assignmentList = _.map(assignments, (assignment,uuid)=>assignment) || []
    const allProgress = attemptList.concat(assignmentList)

    return _.compact(_.map(allProgress, (progress,uuid)=>progress).filter(progress => {
      const startOfToday = moment(Date()).startOf('day')
      if(progress.completed_at) {
        if(moment(progress.completed_at).isAfter(startOfToday)) {
          return progress
        }
      }
    })).length
  }

  const getBreadcrumbItems = ()=> {
    let items = []

    items.push({ text: 'Family', link: '/family' })
    if(!_.isEmpty(currentProfile)) {
      items.push( { text: currentProfile.first_name, link: `/family/${profileId}/` } )
    }

    return items
  }

  return(
    <ImageHeader image={headerImage} titleContents='Track Progress' subtitleText='Stats for your entire family' containerClass='modules-container'>
      <div className="container-fluid padding-25 sm-padding-10">
        <AsyncElements isLoading={isReading || isInitializing}>
          <Breadcrumbs items={getBreadcrumbItems()}/>
          {crudAction === 'LIST' &&
            <div className='row'>
              {_.map(profiles, (profile,uuid)=><ProfileCard profile={profile} uuid={uuid} link={`/family/${uuid}`}/>)}
            </div>
          }
          {crudAction === 'SHOW' &&
            <div className="row">

              <CharacterOverviewCard profile={currentProfile} completedQuestCount={getCompletedQuestCount()} />
              <SingleProfileQuestOverview profile={currentProfile} profileId={profileId} questAttempts={questAttempts} assignments={assignments}/>

            </div>
          }
        </AsyncElements>
      </div>
    </ImageHeader>
  )
}

export default StudentDashboard
